module.exports = {
    'server'       : require('./WebSocketServer'),
    'client'       : require('./WebSocketClient'),
    'router'       : require('./WebSocketRouter'),
    'frame'        : require('./WebSocketFrame'),
    'request'      : require('./WebSocketRequest'),
    'connection'   : require('./WebSocketConnection'),
    'w3cwebsocket' : require('./W3CWebSocket'),
    'deprecation'  : require('./Deprecation'),
    'version'      : require('./version')
};



//////////////////
// WEBPACK FOOTER
// ./~/web3-providers/~/websocket/lib/websocket.js
// module id = 2659
// module chunks = 0 1